import React from 'react';
import {
  DateTimePicker,
  DateTimePickerProps,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { BaseTextField } from '../BaseTextField/BaseTextField';
import DateFnsUtils from '@date-io/date-fns';
import CalendarIco from './calendar-ico.png';
import { IconButton, InputAdornment } from '@material-ui/core';

type PBaseDateTimePicker = DateTimePickerProps & {
  InputProps?: any;
  errorText?: string;
  startPosition?: boolean;
};

export const BaseDateTimePicker: React.FC<PBaseDateTimePicker> = (props) => {
  const { onChange, value, errorText, InputProps = {}, startPosition: disablePosition = false, ...otherProps } = props;
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <DateTimePicker
        format="yyyy-MM-dd hh:mm a"
        ampm
        inputVariant="outlined"
        value={value || null}
        InputProps={{
          endAdornment: (
            <InputAdornment position={disablePosition ? "start" : "end"}>
              <IconButton>
                <img src={CalendarIco} alt="Calendar" />
              </IconButton>
            </InputAdornment>
          ),
          ...InputProps,
        }}
        error={Boolean(errorText)}
        helperText={errorText}
        onChange={onChange}
        // @ts-ignore
        TextFieldComponent={BaseTextField}
        {...otherProps}
      />
    </MuiPickersUtilsProvider>
  );
};
